import React, { FormEvent, useEffect, useState } from 'react'
import { ComponentMethod, IComponent } from '../../../types/component';
import useUpdateComponent from '../../../hooks/component/useUpdateComponent';
import useCreateComponent from '../../../hooks/component/useCreateComponent';
import useDeleteComponent from '../../../hooks/component/useDeleteComponent';

interface IComponentProps {
  component: IComponent;
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsResetNew: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModalMessage: React.Dispatch<React.SetStateAction<{ title: string; subtitle: string; }>>;
};

const Component = ({ component, currOption, setCurrOption, isDelete, setIsDelete, setIsOpenDeleteModal, setIsResetNew, setDeleteModalMessage }: IComponentProps) => {
  const [title, setTitle] = useState<string>(component.id ? component.description : 'New Component');

  const [currentComponent, setCurrentComponent] = useState<IComponent>(component);
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [, setIsServiceError] = useState<string | null>(null); //eslint-disable-line

  useEffect(() => {
    setCurrentComponent(component);
    setTitle(component.id ? component.description : 'New Component');
  }, [component]);

  const { mutate: updateComponent } = useUpdateComponent({ setIsProcessRunning, setIsServiceError });
  const { mutate: createComponent } = useCreateComponent({ setIsProcessRunning, setIsServiceError });
  const { mutate: deleteComponent } = useDeleteComponent();

  useEffect(() => {
    if (isDelete) {
      if (currOption.length - 1 === 2) {
        setCurrOption([currOption[0], currOption[1]]);
      } else {
        setCurrOption([currOption[0], currOption[1], 0]);
      }
      if (!component.id) return;
      deleteComponent(component.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!currentComponent) {
    return <p>Loading...</p>
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    if (!component.id) {
      createComponent(currentComponent);
    } else {
      updateComponent(currentComponent);
    }
    setTitle(currentComponent.description || 'New Component');
  }

  const handleDelete = () => {
    if (!component.id) {
      setIsResetNew(true);
      if (currOption.length - 1 === 2) {
        setCurrOption([currOption[0], currOption[1]]);
      } else {
        setCurrOption([currOption[0], currOption[1], 0]);
      }
    } else {
      setDeleteModalMessage({ title: 'Delete Component', subtitle: 'This will delete all the functions and parameters associated with the component. Are you sure you want to delete?' });
      setIsOpenDeleteModal(true);
    }
  }


  return (
    <div className='imm_admin__content'>
      <div className='content_head'>
        <h3>Component - {title.slice(0, 40) + (title.length > 40 ? ' ...' : '')}</h3>
      </div>

      <form onSubmit={handleSave} className='content_form'>
        <div className='field'>
          <label htmlFor='description'>Description <span className='field__required'>*</span></label>
          <textarea id='description' name='description' placeholder='Enter Description' value={currentComponent.description || ""} onChange={(e) => setCurrentComponent({ ...currentComponent, description: e.target.value })}></textarea>
        </div>

        <div className='field'>
          <label htmlFor='method'>Method <span className='field__required'>*</span></label>
          <select id='method' name='method' value={currentComponent.method} onChange={(e) => setCurrentComponent({ ...currentComponent, method: e.target.value as ComponentMethod })}>
            <option value={ComponentMethod.AND}>and</option>
            <option value={ComponentMethod.OR}>or</option>
            {/* <option value={ComponentMethod.NOT}>not</option>
            <option value={ComponentMethod.NAND}>nand</option>
            <option value={ComponentMethod.NOR}>nor</option>
            <option value={ComponentMethod.XOR}>xor</option> */}
          </select>
        </div>

        <div className='actions'>
          <button className='delete_btn' type="button" onClick={handleDelete}>{!component.id ? 'Cancel' : 'Delete'}</button>
          <button className='save_btn' type='submit'>{isProcessRunning ? <i className='imm_admin__process_loader' /> : !component.id ? 'Create' : 'Save'}</button>
        </div>
      </form>
    </div>
  );
}

export default Component;